module.exports = __webpack_public_path__ + "media/images/logo-global-white-e0ad18a2a9ef85bf3ceb935b0a886d8d.png";